import { render, staticRenderFns } from "./MainEditor.vue?vue&type=template&id=5f6a7a90&scoped=true&"
import script from "./MainEditor.vue?vue&type=script&lang=js&"
export * from "./MainEditor.vue?vue&type=script&lang=js&"
import style0 from "./MainEditor.vue?vue&type=style&index=0&id=5f6a7a90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a7a90",
  null
  
)

export default component.exports